import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PHONE_DISPLAY = '343.558.8820';
export const PHONE_TEL = 'tel:+13435588820';

export const FALLBACK_REVIEWS = [
  { author: 'Sarah M.', location: 'Ottawa, ON', rating: 5, text: 'Fast, professional and the windshield looks perfect. They came to my office and were done in about an hour. Highly recommend!' },
  { author: 'David R.', location: 'Kanata, ON', rating: 5, text: 'Great experience from start to finish. ADAS calibration was done right and they explained everything clearly.' },
  { author: 'Priya K.', location: 'Orleans, ON', rating: 5, text: 'Stone chip fixed same day at a very fair price. Friendly team and super easy to book.' },
];

export function useGoogleReviews() {
  const [data, setData] = useState({ rating: 4.9, total_reviews: null, reviews: FALLBACK_REVIEWS, maps_url: null, live: false });
  useEffect(() => {
    axios.get(`${API}/public/google-reviews`)
      .then((r) => {
        const d = r.data;
        if (!d?.available) return;
        setData({
          rating: d.rating || 4.9,
          total_reviews: d.total_reviews,
          reviews: d.reviews?.length ? d.reviews : FALLBACK_REVIEWS,
          maps_url: d.maps_url,
          live: true,
        });
      })
      .catch(() => {});
  }, []);
  return data;
}

export function useLocations() {
  const [locations, setLocations] = useState([]);
  useEffect(() => {
    axios.get(`${API}/public/locations`).then((r) => setLocations(r.data || [])).catch(() => {});
  }, []);
  return locations;
}

export function scrollToQuote() {
  const el = document.getElementById('mobile-quote');
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }
  return false;
}

export function requestQuote() {
  if (!scrollToQuote()) window.dispatchEvent(new Event('open-quote-modal'));
}
